import abTests from 'frontend/shared/javascripts/modules/ab_tests'
import { onConsentReady } from 'frontend/shared/javascripts/util/gdpr_consent'
import { setCookie } from 'shared/javascripts/util/cookies'
import { replaceLocation } from 'shared/javascripts/util/navigation'

// mirrors VideoPlatform::Studybuddy::Rollout::VARIANT_COOKIE
export const STUDYBUDDY_VARIANT_COOKIE = 'studybuddy_variant'
export const STUDYBUDDY_VARIANT_COOKIE_DAYS = 30

export type StudybuddyVariant = 'a' | 'b'

export function watchStudybuddyVariant(
  callback?: (variant: StudybuddyVariant) => void,
): () => void {
  return abTests.onVariant('studybuddy', (variant) => {
    setCookie(STUDYBUDDY_VARIANT_COOKIE, variant, { days: STUDYBUDDY_VARIANT_COOKIE_DAYS })
    callback?.(variant)
  })
}

// Leaves the page once the visitor is bucketed into `variant`. The redirect waits for consent: until
// then Convert holds back the bucketing report, and leaving the page would lose it. Once consent is
// resolved, boot/gdpr.ts has already told Convert about it (both listen on the same event, and boot
// registers first).
export function redirectOnStudybuddyVariant(
  variant: StudybuddyVariant,
  url: () => string,
): () => void {
  let cancelRedirect = (): void => {}

  const stopWatching = watchStudybuddyVariant((decided) => {
    cancelRedirect()
    cancelRedirect = decided === variant ? onConsentReady(() => replaceLocation(url())) : () => {}
  })

  return () => {
    stopWatching()
    cancelRedirect()
  }
}
